// hovered-cards.js
// Control overlay visibility for hovered cards (desktop & mobile)
document.addEventListener('DOMContentLoaded', function () {
  const cards = document.querySelectorAll('.hovered-card');

  cards.forEach(card => {
    const overlayDefault = card.querySelector('.hovered-card__overlay--default');
    const overlayHover = card.querySelector('.hovered-card__overlay--hover');
    const openBtn = overlayDefault.querySelector('.open');
    const closeBtn = overlayHover.querySelector('.close');

    // Helper functions
    function showOverlay() {
      card.classList.add('is-active');
    }
    function hideOverlay() {
      card.classList.remove('is-active');
    }

    // Desktop: mouseenter/mouseleave
    card.addEventListener('mouseenter', () => {
      if (window.innerWidth > 768) {
        showOverlay();
      }
    });
    card.addEventListener('mouseleave', () => {
      if (window.innerWidth > 768) {
        hideOverlay();
      }
    });

    // Mobile: open button click
    if (openBtn) {
      openBtn.addEventListener('click', function (e) {
        if (window.innerWidth <= 768) {
          showOverlay();
          e.stopPropagation();
        }
      });
    }

    // Mobile: close button click
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        if (window.innerWidth <= 768) {
          hideOverlay();
          e.stopPropagation();
        }
      });
    }
  });
});
